import { Table, Tag, Space, Button, Popconfirm, Typography } from "antd";
import { EditOutlined, StopOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const formatLimit = (value) =>
    value === null || value === undefined ? (
        <Text type="secondary">Unlimited</Text>
    ) : (
        value
    );

const BillingPlansTable = ({ plans, loading, onEdit, onSetStatus }) => {
    const columns = [
        {
            title: "Key",
            dataIndex: "key",
            key: "key",
            width: 110,
            render: (key) => <Text code>{key}</Text>,
        },
        {
            title: "Name",
            key: "name",
            render: (_, record) => (
                <Space direction="vertical" size={0}>
                    <Space size={6} wrap>
                        <span>{record.name?.en || "—"}</span>
                        {record.is_default && <Tag color="blue">Default</Tag>}
                        {record.is_featured && <Tag color="gold">Featured</Tag>}
                    </Space>
                    {record.name?.ar ? (
                        <Text type="secondary" style={{ fontSize: 12 }} dir="rtl">
                            {record.name.ar}
                        </Text>
                    ) : null}
                </Space>
            ),
        },
        {
            title: "AI / mo",
            key: "ai",
            width: 90,
            render: (_, r) => formatLimit(r.limits?.ai_requests_monthly),
        },
        {
            title: "Smart AI / mo",
            key: "polar",
            width: 100,
            render: (_, r) => formatLimit(r.limits?.polar_summaries_monthly),
        },
        {
            title: "Properties",
            key: "props",
            width: 100,
            render: (_, r) => formatLimit(r.limits?.ga4_properties),
        },
        {
            title: "Members",
            key: "members",
            width: 90,
            render: (_, r) => formatLimit(r.limits?.invited_members),
        },
        {
            title: "Replays",
            key: "replays",
            width: 90,
            render: (_, r) => formatLimit(r.limits?.replay_sessions_month),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 110,
            filters: [
                { text: "Active", value: "active" },
                { text: "Inactive", value: "inactive" },
            ],
            onFilter: (value, record) => record.status === value,
            render: (status) =>
                status === "active" ? (
                    <Tag color="success">Active</Tag>
                ) : (
                    <Tag>Inactive</Tag>
                ),
        },
        {
            title: "Order",
            dataIndex: "display_order",
            key: "display_order",
            width: 72,
            sorter: (a, b) => (a.display_order || 0) - (b.display_order || 0),
            defaultSortOrder: "ascend",
        },
        {
            title: "Actions",
            key: "actions",
            fixed: "right",
            width: 200,
            render: (_, record) => {
                const isActive = record.status === "active";
                return (
                    <Space size={0}>
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => onEdit(record)}
                        >
                            Edit
                        </Button>
                        <Popconfirm
                            title={
                                isActive
                                    ? "Set inactive? Plan will hide from public pricing."
                                    : "Set active? Plan will show on public pricing."
                            }
                            onConfirm={() =>
                                onSetStatus(record, isActive ? "inactive" : "active")
                            }
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button
                                type="link"
                                danger={isActive}
                                icon={
                                    isActive ? (
                                        <StopOutlined />
                                    ) : (
                                        <CheckCircleOutlined />
                                    )
                                }
                            >
                                {isActive ? "Deactivate" : "Activate"}
                            </Button>
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={plans}
            loading={loading}
            pagination={{ pageSize: 10, showSizeChanger: true }}
            rowKey={(record) => record.key || record._id}
            scroll={{ x: 980 }}
            size="middle"
        />
    );
};

export default BillingPlansTable;
